export const getLocationRoute = () => {
  const savedPath = sessionStorage.getItem('pathNeeded');

  return savedPath || '/locations/place/-78.549668/39.014/7';
};
